import { Link } from 'react-router-dom';
import type { Movie } from '@/types/movie';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  const typeLabel = movie.type === 'movie' ? '电影' : '电视剧';
  const typeClass =
    movie.type === 'movie'
      ? 'bg-primary-500 text-background-50'
      : 'bg-accent-500 text-background-50';

  return (
    <Link to={`/detail/${movie.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}海报`}
          title={`${movie.title} - 高清${typeLabel}在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/85 via-background-50/5 to-transparent"></div>
        <span className={`absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-semibold ${typeClass}`}>
          {typeLabel}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-[11px] font-bold bg-background-50/80 text-primary-400 flex items-center gap-0.5">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-background-50/40">
          <span className="w-12 h-12 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>
      </div>
      <h3 className="mt-2.5 text-sm font-semibold text-foreground-100 truncate group-hover:text-primary-400 transition-colors">
        {movie.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500 truncate">
        {movie.year} · {movie.region} · {movie.genres[0]}
      </p>
    </Link>
  );
}